import { Box, chakra, GridItem, Link } from '@chakra-ui/react'
import { LinkRowProps } from './types'
import { useContext } from 'react'
import { NavigationContext } from './Navigation'
import NextLink from 'next/link'

const LinkRow = ({
  colStart,
  colSpan = 12,
  items,
  hasSubMenu = false,
  isSubMenu = false,
  title,
  className,
  theme = 'brand',
  children,
  ...props
}: LinkRowProps) => {
  const { setIsOpen, setActiveIndex } = useContext(NavigationContext)

  return (
    <GridItem
      className={className}
      colSpan={colSpan}
      colStart={colStart}
      display='flex'
      alignItems='center'
      {...props}
    >
      {title && (
        <chakra.span px={6} mb={2} fontWeight='bold'>
          {title}
        </chakra.span>
      )}
      {items?.map((item, index) => {
        const shouldTriggerSubMenu = hasSubMenu && item.subItems ? true : false
        const hideSubMenu = !hasSubMenu && isSubMenu
        return item.url ? (
          <Link
            px={6}
            as={NextLink}
            href={item.url}
            cursor='pointer'
            key={index}
            onMouseEnter={() => {
              setIsOpen(hideSubMenu)
            }}
          >
            {item.text}
          </Link>
        ) : (
          <Box
            px={6}
            key={index}
            onMouseEnter={() => {
              setIsOpen(shouldTriggerSubMenu),
                shouldTriggerSubMenu && setActiveIndex(index)
            }}
            cursor='pointer'
          >
            {item.text}
          </Box>
        )
      })}
      {children}
    </GridItem>
  )
}

export default LinkRow
